import React, { useState } from 'react'
import { Link } from 'react-router-dom'

// ─── SEO Data ────────────────────────────────────────────────────────────────
// const TABS = [
//   {
//     id: 'areas',
//     label: 'Popular areas',
//     links: [
//       { text: 'PG in Mukherjee Nagar',    to: '/listings?location=Mukherjee Nagar' },
//       { text: 'PG in Karol Bagh',           to: '/listings?location=Karol Bagh' },
//       { text: 'PG in Old Rajendra Nagar',           to: '/listings?location=Old Rajendra Nagar' },
//       { text: 'PG in Laxmi Nagar',         to: '/listings?location=Laxmi Nagar' },
//       { text: 'PG in Rajouri Garden',       to: '/listings?location=Rajouri Garden' },
//       { text: 'PG in Dwarka',               to: '/listings?location=Dwarka' },
//       { text: 'PG in Rohini',               to: '/listings?location=Rohini' },
//       { text: 'PG in Saket',                to: '/listings?location=Saket' },
//       { text: 'PG in Lajpat Nagar',         to: '/listings?location=Lajpat Nagar' },
//       { text: 'PG in Malviya Nagar',        to: '/listings?location=Malviya Nagar' },
//       { text: 'PG in Connaught Place',      to: '/listings?location=Connaught Place' },
//       { text: 'PG in Pitampura',            to: '/listings?location=Pitampura' },
//       { text: 'PG in Vasant Kunj',          to: '/listings?location=Vasant Kunj' },
//       { text: 'PG in Janakpuri',            to: '/listings?location=Janakpuri' },
//       { text: 'PG in Hauz Khas',            to: '/listings?location=Hauz Khas' },
//       { text: 'PG in Nehru Place',          to: '/listings?location=Nehru Place' },
//       { text: 'PG in Okhla',               to: '/listings?location=Okhla' },
//       { text: 'PG in Greater Kailash',      to: '/listings?location=Greater Kailash' },
//       { text: 'PG in Paharganj',            to: '/listings?location=Paharganj' },
//       { text: 'PG in Shahdara',             to: '/listings?location=Shahdara' },
//     ],
//   },
//   {
//     id: 'colleges',
//     label: 'Near colleges',
//     links: [
//       { text: 'PG near North Campus DU',    to: '/listings?location=North Campus' },
//       { text: 'PG near South Campus DU',    to: '/listings?location=South Campus' },
//       { text: 'PG near Miranda House',      to: '/listings?location=Miranda House' },
//       { text: 'PG near GTB Nagar',          to: '/listings?location=GTB Nagar' },
//       { text: 'PG near Hudson Lane',        to: '/listings?location=Hudson Lane' },
//       { text: 'PG near Kamla Nagar',        to: '/listings?location=Kamla Nagar' },
//       { text: 'PG near IP University',      to: '/listings?location=IP University' },
//       { text: 'PG near Jamia Millia',       to: '/listings?location=Jamia Nagar' },
//       { text: 'PG near JNU',               to: '/listings?location=JNU' },
//       { text: 'PG near LSR College',        to: '/listings?location=Lodi Road' },
//       { text: 'PG near Hindu College',      to: '/listings?location=North Campus' },
//       { text: 'PG near Hansraj College',    to: '/listings?location=North Campus' },
//       { text: 'PG near SRCC',              to: '/listings?location=North Campus' },
//       { text: 'PG near Gargi College',      to: '/listings?location=South Campus' },
//       { text: 'PG near NSIT Dwarka',        to: '/listings?location=Dwarka' },
//       { text: 'PG near IGNOU',             to: '/listings?location=Vasant Kunj' },
//       { text: 'PG near Ramjas College',     to: '/listings?location=North Campus' },
//       { text: 'PG near Maitreyi College',   to: '/listings?location=South Campus' },
//       { text: 'PG near Kirori Mal College', to: '/listings?location=North Campus' },
//       { text: 'PG near Indraprastha College',to: '/listings?location=North Campus' },
//     ],
//   },
//   {
//     id: 'upsc',
//     label: 'UPSC & coaching',
//     links: [
//       { text: 'PG near Old Rajinder Nagar', to: '/listings?location=Rajendra Nagar' },
//       { text: 'PG near Mukherjee Nagar coaching', to: '/listings?location=Mukherjee Nagar' },
//       { text: 'PG near Vajiram & Ravi',     to: '/listings?location=Rajendra Nagar' },
//       { text: 'PG near Vision IAS',         to: '/listings?location=Mukherjee Nagar' },
//       { text: 'PG near Drishti IAS',        to: '/listings?location=Mukherjee Nagar' },
//       { text: 'PG near Chanakya IAS',       to: '/listings?location=Rajendra Nagar' },
//       { text: 'PG near Rau\'s IAS Circle',  to: '/listings?location=Rajendra Nagar' },
//       { text: 'PG near ALS IAS',            to: '/listings?location=Mukherjee Nagar' },
//       { text: 'PG near Patel Nagar',        to: '/listings?location=Patel Nagar' },
//       { text: 'PG near Satya Niketan',      to: '/listings?location=Satya Niketan' },
//       { text: 'PG for UPSC students Delhi', to: '/listings?location=Mukherjee Nagar' },
//       { text: 'Budget PG for UPSC',         to: '/listings?location=Mukherjee Nagar' },
//       { text: 'PG near Karol Bagh coaching',to: '/listings?location=Karol Bagh' },
//       { text: 'PG near Shri Ram IAS',       to: '/listings?location=Rajendra Nagar' },
//       { text: 'Girls PG near UPSC coaching',to: '/listings?location=Mukherjee Nagar' },
//       { text: 'PG near Elite IAS',          to: '/listings?location=Mukherjee Nagar' },
//       { text: 'PG near Plutus IAS',         to: '/listings?location=Mukherjee Nagar' },
//       { text: 'PG with study room Delhi',   to: '/listings?location=Rajendra Nagar' },
//       { text: 'Single room PG UPSC Delhi',  to: '/listings?location=Mukherjee Nagar' },
//       { text: 'PG near IAS hub Rajinder Nagar', to: '/listings?location=Rajendra Nagar' },
//     ],
//   },
//   {
//     id: 'type',
//     label: 'By type',
//     links: [
//       { text: 'Girls PG in Delhi',          to: '/listings?location=Delhi' },
//       { text: 'Boys PG in Delhi',           to: '/listings?location=Delhi' },
//       { text: 'Co-living spaces Delhi',     to: '/listings?location=Delhi' },
//       { text: 'Single room PG Delhi',       to: '/listings?location=Delhi' },
//       { text: 'Double sharing PG Delhi',    to: '/listings?location=Delhi' },
//       { text: 'Triple sharing PG Delhi',    to: '/listings?location=Delhi' },
//       { text: 'PG with food Delhi',         to: '/listings?location=Delhi' },
//       { text: 'PG with WiFi Delhi',         to: '/listings?location=Delhi' },
//       { text: 'Furnished PG Delhi',         to: '/listings?location=Delhi' },
//       { text: 'AC PG in Delhi',             to: '/listings?location=Delhi' },
//       { text: 'Monthly PG Delhi',           to: '/listings?location=Delhi' },
//       { text: 'Short-stay PG Delhi',        to: '/listings?location=Delhi' },
//       { text: 'Budget PG Delhi',            to: '/listings?location=Delhi' },
//       { text: 'Premium PG Delhi',           to: '/listings?location=Delhi' },
//       { text: 'PG with gym Delhi',          to: '/listings?location=Delhi' },
//       { text: 'PG with parking Delhi',      to: '/listings?location=Delhi' },
//       { text: 'Working professionals PG',   to: '/listings?location=Delhi' },
//       { text: 'PG near Noida border',       to: '/listings?location=Laxmi Nagar' },
//       { text: 'PG near Gurgaon border',     to: '/listings?location=Dwarka' },
//       { text: 'Hostel in Delhi',            to: '/listings?location=Delhi' },
//     ],
//   },
//   {
//     id: 'metro',
//     label: 'Near metro',
//     links: [
//       { text: 'PG near Hauz Khas Metro',        to: '/listings?location=Hauz Khas' },
//       { text: 'PG near Vishwavidyalaya Metro',   to: '/listings?location=North Campus' },
//       { text: 'PG near Rajiv Chowk Metro',       to: '/listings?location=Connaught Place' },
//       { text: 'PG near Nehru Place Metro',       to: '/listings?location=Nehru Place' },
//       { text: 'PG near Dwarka Sec 21 Metro',     to: '/listings?location=Dwarka' },
//       { text: 'PG near Karol Bagh Metro',        to: '/listings?location=Karol Bagh' },
//       { text: 'PG near Laxmi Nagar Metro',       to: '/listings?location=Laxmi Nagar' },
//       { text: 'PG near Rohini Metro',            to: '/listings?location=Rohini' },
//       { text: 'PG near Pitampura Metro',         to: '/listings?location=Pitampura' },
//       { text: 'PG near GTB Nagar Metro',         to: '/listings?location=GTB Nagar' },
//       { text: 'PG near Saket Metro',             to: '/listings?location=Saket' },
//       { text: 'PG near Malviya Nagar Metro',     to: '/listings?location=Malviya Nagar' },
//       { text: 'PG near Janakpuri Metro',         to: '/listings?location=Janakpuri' },
//       { text: 'PG near Inderlok Metro',          to: '/listings?location=Rohini' },
//       { text: 'PG near Uttam Nagar Metro',       to: '/listings?location=Dwarka' },
//       { text: 'PG near Vaishali Metro',          to: '/listings?location=Laxmi Nagar' },
//       { text: 'PG near Welcome Metro',           to: '/listings?location=Shahdara' },
//       { text: 'PG near Shahdara Metro',          to: '/listings?location=Shahdara' },
//       { text: 'PG near Noida Sector 18 Metro',   to: '/listings?location=Laxmi Nagar' },
//       { text: 'PG near HUDA City Centre',        to: '/listings?location=Dwarka' },
//     ],
//   },
// ]

// so Google crawls every single link regardless of which tab is active.
const TABS = [
  {
    id: 'areas',
    label: 'Popular areas',
    links: [
      { text: 'PG in Mukherjee Nagar',    to: '/pg-in-mukherjee-nagar' },
      { text: 'PG in Karol Bagh',          to: '/pg-in-karol-bagh' },
      { text: 'PG in Old Rajendra Nagar',  to: '/pg-in-old-rajendra-nagar' },
      { text: 'PG in Laxmi Nagar',         to: '/pg-in-laxmi-nagar' },
      { text: 'PG in Rajouri Garden',      to: '/pg-in-rajouri-garden' },
      { text: 'PG in Dwarka',              to: '/pg-in-dwarka' },
      { text: 'PG in Rohini',              to: '/pg-in-rohini' },
      { text: 'PG in Saket',               to: '/pg-in-saket' },
      { text: 'PG in Lajpat Nagar',        to: '/pg-in-lajpat-nagar' },
      { text: 'PG in Malviya Nagar',       to: '/pg-in-malviya-nagar' },
      { text: 'PG in Connaught Place',     to: '/pg-in-connaught-place' },
      { text: 'PG in Pitampura',           to: '/pg-in-pitampura' },
      { text: 'PG in Vasant Kunj',         to: '/pg-in-vasant-kunj' },
      { text: 'PG in Janakpuri',           to: '/pg-in-janakpuri' },
      { text: 'PG in Hauz Khas',           to: '/pg-in-hauz-khas' },
      { text: 'PG in Nehru Place',         to: '/pg-in-nehru-place' },
      { text: 'PG in Okhla',              to: '/pg-in-okhla' },
      { text: 'PG in Greater Kailash',    to: '/pg-in-greater-kailash' },
      { text: 'PG in Paharganj',           to: '/pg-in-paharganj' },
      { text: 'PG in Shahdara',            to: '/pg-in-shahdara' },
    ],
  },
  {
    id: 'colleges',
    label: 'Near colleges',
    links: [
      { text: 'PG near North Campus',     to: '/pg-near-north-campus' },
      { text: 'PG near South Campus',     to: '/pg-near-south-campus' },
      { text: 'PG near Miranda House',       to: '/pg-near-miranda-house' },
      { text: 'PG near GTB Nagar',           to: '/pg-near-gtb-nagar' },
      { text: 'PG near Hudson Lane',         to: '/pg-near-hudson-lane' },
      { text: 'PG near Kamla Nagar',         to: '/pg-near-kamla-nagar' },
      { text: 'PG near IP University',       to: '/pg-near-ip-university' },
      { text: 'PG near Jamia Millia',        to: '/pg-near-jamia-millia' },
      { text: 'PG near JNU',                to: '/pg-near-jnu' },
      { text: 'PG near LSR College',         to: '/pg-near-lsr-college' },
      { text: 'PG near Hindu College',       to: '/pg-near-hindu-college' },
      { text: 'PG near Hansraj College',     to: '/pg-near-hansraj-college' },
      { text: 'PG near SRCC',               to: '/pg-near-srcc' },
      { text: 'PG near Gargi College',       to: '/pg-near-gargi-college' },
      { text: 'PG near IIT Delhi',         to: '/pg-near-iit-delhi' },
      { text: 'PG near IGNOU',              to: '/pg-near-ignou' },
      { text: 'PG near Ramjas College',      to: '/pg-near-ramjas-college' },
      { text: 'PG near Maitreyi College',    to: '/pg-near-maitreyi-college' },
      { text: 'PG near Kirori Mal College',  to: '/pg-near-kirori-mal-college' },
      { text: 'PG near Indraprastha College',to: '/pg-near-indraprastha-college' },
    ],
  },
  {
    id: 'upsc',
    label: 'UPSC & coaching',
    links: [
      { text: 'PG near Rajinder Nagar',          to: '/pg-near-rajendra-nagar' },
      { text: 'PG near Mukherjee Nagar',         to: '/pg-near-mukherjee-nagar' },
      { text: 'PG near Vajiram & Ravi',          to: '/pg-near-vajiram-ravi' },
      { text: 'PG near Vision IAS',              to: '/pg-near-vision-ias' },
      { text: 'PG near Drishti IAS',             to: '/pg-near-drishti-ias' },
      { text: 'PG near Chanakya IAS',            to: '/pg-near-chanakya-ias' },
      { text: 'PG near ALS IAS',                 to: '/pg-near-als-ias' },
      { text: 'PG near Patel Nagar',             to: '/pg-near-patel-nagar' },
      { text: 'PG near Satya Niketan',           to: '/pg-near-satya-niketan' },
      { text: 'PG near Vajirao & Reddy',         to: '/pg-near-vajirao-and-reddy' },
      { text: 'PG near Shri Ram IAS',            to: '/pg-near-shri-ram-ias' },
      { text: 'PG near Elite IAS',               to: '/pg-near-elite-ias' },
      { text: 'PG near First IAS',               to: '/pg-near-first-ias' },
      { text: 'PG near NEXT IAS',                to: '/pg-near-next-ias' },
    ],
  },
  {
    id: 'type',
    label: 'By type',
    links: [
      { text: 'Girls PG in Delhi',         to: '/pg-girls-in-delhi' },
      { text: 'Boys PG in Delhi',          to: '/pg-boys-in-delhi' },
      { text: 'Co-living spaces Delhi',    to: '/pg-coed-in-delhi' },
      { text: 'Single room PG Delhi',      to: '/pg-single-in-delhi' },
      { text: 'Double sharing PG Delhi',   to: '/pg-double-in-delhi' },
      { text: 'Triple sharing PG Delhi',   to: '/pg-triple-in-delhi' },
    ],
  },
  {
    id: 'metro',
    label: 'Near metro station',
    links: [
      { text: 'PG near Hauz Khas Metro Station',       to: '/pg-near-hauz-khas-metro-station' },
      { text: 'PG near Vishwavidyalaya Metro Station',  to: '/pg-near-vishwavidyalaya-metro-station' },
      { text: 'PG near Rajiv Chowk Metro Station',      to: '/pg-near-rajiv-chowk-metro-station' },
      { text: 'PG near Nehru Place Metro Station',      to: '/pg-near-nehru-place-metro-station' },
      { text: 'PG near Dwarka Sec 21 Metro Station',    to: '/pg-near-dwarka-sec-21-metro-station' },
      { text: 'PG near Karol Bagh Metro Station',       to: '/pg-near-karol-bagh-metro-station' },
      { text: 'PG near Laxmi Nagar Metro Station',      to: '/pg-near-laxmi-nagar-metro-station' },
      { text: 'PG near Rohini Metro Station',           to: '/pg-near-rohini-metro-station' },
      { text: 'PG near Pitampura Metro Station',        to: '/pg-near-pitampura-metro-station' },
      { text: 'PG near GTB Nagar Metro Station',        to: '/pg-near-gtb-nagar-metro-station' },
      { text: 'PG near Saket Metro Station',            to: '/pg-near-saket-metro-station' },
      { text: 'PG near Malviya Nagar Metro Station',    to: '/pg-near-malviya-nagar-metro-station' },
      { text: 'PG near Janakpuri Metro Station',        to: '/pg-near-janakpuri-metro-station' },
      { text: 'PG near Inderlok Metro Station',         to: '/pg-near-indirlok-metro-station' },
      { text: 'PG near Uttam Nagar Metro Station',      to: '/pg-near-uttam-nagar-metro-station' },
      { text: 'PG near Vaishali Metro Station',         to: '/pg-near-vaishali-metro-station' },
      { text: 'PG near Welcome Metro Station',          to: '/pg-near-welcome-metro-station' },
      { text: 'PG near Shahdara Metro Station',         to: '/pg-near-shahdara-metro-station' },
      { text: 'PG near Noida Sector 18 Metro Station',  to: '/pg-near-noida-sector-18-metro-station' },
      { text: 'PG near Pitampura Metro Station',        to: '/pg-near-pitampura-metro-station' },
    ],
  },
]

const SOCIAL_LINKS = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/aapkapg?igsh=MWI0cXFjYTVxdmp1Nw==',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
      </svg>
    ),
  },
  {
    label: 'Facebook',
    href: '#',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
  },
  {
    label: 'X (Twitter)',
    href: '#',
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
      </svg>
    ),
  },
  {
    label: 'LinkedIn',
    href: '#',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
      </svg>
    ),
  },
]

const BOTTOM_LINKS = [
  { text: 'Privacy policy', to: '/privacypolicy' },
  // { text: 'Terms & conditions', to: '/terms' },
  { text: 'About us', to: '/about' },
  { text: 'Contact', to: '/contact' },
  { text: 'Blog', to: '/blog' },
]

// ─── Component ────────────────────────────────────────────────────────────────
const Footer = () => {
  const [activeTab, setActiveTab] = useState(0)

  return (
    <footer className="site-footer">

      {/* ── SEO link section with tabs ── */}
      <div className="site-footer__seo">
        {/* Tab buttons */}
        <div className="site-footer__tabs" role="tablist" aria-label="Browse PGs by category">
          {TABS.map((tab, i) => (
            <button
              key={tab.id}
              role="tab"
              aria-selected={activeTab === i}
              aria-controls={`footer-panel-${tab.id}`}
              id={`footer-tab-${tab.id}`}
              className={`site-footer__tab${activeTab === i ? ' site-footer__tab--active' : ''}`}
              onClick={() => setActiveTab(i)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Link panels — all rendered for SEO, visibility toggled via CSS */}
        <div className="site-footer__panels">
          {TABS.map((tab, i) => (
            <div
              key={tab.id}
              id={`footer-panel-${tab.id}`}
              role="tabpanel"
              aria-labelledby={`footer-tab-${tab.id}`}
              className={`site-footer__panel${activeTab === i ? ' site-footer__panel--active' : ''}`}
            >
              {tab.links.map((link) => (
                <Link
                  key={link.text}
                  to={link.to}
                  className="site-footer__link"
                >
                  {link.text}
                </Link>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* ── Bottom bar ── */}
      <div className="site-footer__bottom">
        <p className="site-footer__copy">
          &copy; {new Date().getFullYear()} <strong>AapkaPG</strong>.com product of Fast Management Service Private Limited.
        </p>

        <nav className="site-footer__nav" aria-label="Footer navigation">
          {BOTTOM_LINKS.map((link, i) => (
            <React.Fragment key={link.text}>
              <Link to={link.to} className="site-footer__nav-link">
                {link.text}
              </Link>
              {i < BOTTOM_LINKS.length - 1 && (
                <span className="site-footer__nav-sep" aria-hidden="true" />
              )}
            </React.Fragment>
          ))}
        </nav>

        <div className="site-footer__social" aria-label="Social media links">
          {SOCIAL_LINKS.map((s) => (
            <a
              key={s.label}
              href={s.href}
              className="site-footer__social-btn"
              aria-label={s.label}
              target="_blank"
              rel="noopener noreferrer"
            >
              {s.icon}
            </a>
          ))}
        </div>
      </div>

    </footer>
  )
}

export default Footer